import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ListPage } from "@/features/my/list";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  // Lenient, read by `memberListGroupOf`: "recommended" opens that tab, and any
  // other value (an older link's `in-progress`) opens Your to-dos.
  tab: z.string().optional(),
  listItemId: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/(member)/(protected)/my/list/")({
  validateSearch: searchSchema,
  component: ListPage,
});
